module.exports = __webpack_public_path__ + "static/img/NSW-13.325f18c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-13.jpg
// module id = uoll
// module chunks = 0